<div>
  <div class="d-flex justify-content-end align-items-center">
    <button class="btn btn-info text-left m-2" (click)="addRow()">
      Add rows
    </button>
  </div>

  <table class="table table-fixed table-striped table-bordered table-hover">
    <thead>
      <tr>
        <th scope="col">No.</th>
        <th scope="col">Startup</th>
        <th scope="col">Valuation M$</th>
        <th scope="col">Funds Raised</th>
        <th scope="col">Location</th>
        <th scope="col">Delete</th>
      </tr>
    </thead>
    <tbody class="table-group-divider">
      <tr *ngFor="let row of rows; let i = index">
        <td>
          {{ i + 1 }}
        </td>
        <th scope="row">
          <input
            type="text"
            [(ngModel)]="row.startup"
            placeholder="Enter startup"
          />
        </th>
        <td>
          <input
            type="number"
            [(ngModel)]="row.valuation"
            placeholder="Enter value"
          />
        </td>
        <td>
          <input
            type="text"
            [(ngModel)]="row.funds"
            placeholder="Enter funds"
          />
        </td>
        <td>
          <input
            type="text"
            [(ngModel)]="row.location"
            placeholder="Enter location"
          />
        </td>

        <td class="d-flex justify-content-center align-items-center">
          <button class="btn btn-danger" (click)="deleteRow(i)">
            <i class="fa fa-trash"></i>
          </button>
        </td>
      </tr>
    </tbody>

    <tfoot>
      <tr>
        <th colspan="1">Average</th>
        <td>{{ calculateValuation() | number : "1.2-2" }}</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <th colspan="1">Pessimistic</th>
        <td>
          <input
            (input)="calculateValuation()"
            type="number"
            [(ngModel)]="Pessimisticvalue"
            placeholder="Enter Value"
          />
        </td>
        <td></td>
        <td></td>
      </tr>
    </tfoot>
  </table>
</div>
